class MegaMenu extends HTMLElement {
  connectedCallback() {
    if (!this.classList.contains('mega-menu--has-panel')) return;

    this.trigger = this.querySelector('.mega-menu__trigger');
    this.panel = this.querySelector('.mega-menu__panel');
    this.closeTimer = null;

    this.addEventListener('mouseenter', () => this.open());
    this.addEventListener('mouseleave', () => this.scheduleClose());
    this.trigger.addEventListener('focus', () => this.open());
    this.trigger.addEventListener('click', (e) => {
      if (window.matchMedia('(max-width: 767px)').matches) {
        e.preventDefault();
        this.toggle();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('mega-menu--open')) {
        this.close();
        this.trigger.focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });
  }

  open() {
    clearTimeout(this.closeTimer);
    this.liftPanel();
    this.classList.add('mega-menu--open');
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.classList.remove('mega-menu--open');
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  toggle() {
    if (this.classList.contains('mega-menu--open')) {
      this.close();
    } else {
      this.open();
    }
  }

  // The panel normally starts at the bottom of the header, leaving a strip
  // of header below the trigger. Pull the panel up to the bottom of the
  // trigger text (as a transparent top border, so the content stays put) so the
  // pointer is inside the panel as soon as it leaves the trigger, and a
  // diagonal move towards the right-hand links never crosses the next
  // trigger on the way.
  liftPanel() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.panel.style.removeProperty('--mega-menu-lift');
      return;
    }
    this.panel.style.setProperty('--mega-menu-lift', '0px');
    // Measure to the bottom of the trigger text, not its padding box, so the
    // panel also covers the padding strip under the neighbouring triggers.
    const triggerPadding = parseFloat(getComputedStyle(this.trigger).paddingBottom) || 0;
    const textBottom = this.trigger.getBoundingClientRect().bottom - triggerPadding;
    const lift = this.panel.getBoundingClientRect().top - textBottom;
    this.panel.style.setProperty('--mega-menu-lift', Math.max(0, Math.floor(lift)) + 'px');
  }

  scheduleClose() {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.close(), 120);
  }
}

if (!customElements.get('mega-menu')) {
  customElements.define('mega-menu', MegaMenu);
}
